const moveTabsScroll = ({ element, delta, behavior = 'smooth' }) => {
  const { scrollLeft } = element;
  element.scrollTo({ left: scrollLeft + delta, behavior });
};

export default moveTabsScroll;
